'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ImportantDevices = function ImportantDevices(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 32 32"
  }), React__default["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("path", {
    d: "M0 0L32 0 32 32 0 32z"
  }), React__default["default"].createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M27 15.01L22 15c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM27 24h-5v-7h5v7zM24 6H6c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h7v2h-2v2h8v-2h-2v-2h2v-2H6V8h18v5h2V8c0-1.11-.9-2-2-2zm-8.03 7L15 10l-.97 3H11l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L19 13h-3.03z"
  })));
};

var ImportantDevices$1 = iconStyles()(ImportantDevices);

module.exports = ImportantDevices$1;
